/**
 * Parses native fetch response to internal fetch format
 * @param request native fetch's request
 * @param requestParams request's params
 * @param response native fetch's response
 * @returns parsed response
 */
export async function mapToFetchResponse(request, requestParams, response) {
    const data = await extractContent(response, requestParams.responseContentType);
    const meta = { request, response, requestParams };
    if (!response.ok) {
        const fetchResponse = {
            error: {
                status: response.status,
                data,
            },
            meta,
        };
        return fetchResponse;
    }
    const fetchResponse = {
        data,
        meta,
    };
    return fetchResponse;
}
/**
 * Extracts the content from the response.
 * @param response - Response of the request.
 * @param responseContentType - Response content type.
 * @returns Content of the response.
 */
async function extractContent(response, responseContentType) {
    const contentType = responseContentType || getContentType(response);
    if (contentType == 'json') {
        return await response.json();
    }
    if (contentType == 'blob') {
        return await response.blob();
    }
    return await response.text();
}
function getContentType(response) {
    if (response.headers && response.headers.has('content-type')) {
        const contentType = response.headers.get('content-type').toLowerCase();
        if (contentType.indexOf('application/json') >= 0) {
            return 'json';
        }
        if (contentType.indexOf('image/') >= 0) {
            return 'blob';
        }
        if (contentType.indexOf('video/') >= 0) {
            return 'blob';
        }
        if (contentType.indexOf('application/pdf') >= 0) {
            return 'blob';
        }
    }
    return 'text';
}
